import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { useDispatch, useSelector } from "react-redux";
import { generarLogLibra } from "../../actions/portal";

export const PayPalPayment = ({ handlePaymentSuccess, idPedidoPaypal }) => {
    const dispatch = useDispatch();
    const moneda = useSelector(state => state.precios.moneda)


    const clientId = useSelector(state => state.formasPago?.forma_pago?.parama_1 ?? null)
    const initialOptions = {
        clientId: clientId,
        currency: moneda,
        intent: "capture",
    };

    const style = {
        disableMaxWidth: true,

    };

    return (
        <PayPalScriptProvider options={initialOptions}>
            <PayPalButtons
                fundingSource="paypal"
                style={style}
                createOrder={() => {
                    return idPedidoPaypal
                }}
                onApprove={async (data, actions) => {
                    try {
                        handlePaymentSuccess();
                    } catch (error) {
                        dispatch(generarLogLibra({ mensaje: 'No se ha podido completar la integración del pedido de redsys con id:  ' + idPedidoPaypal, paquete: 'PayPalPayment', punto: '30' }))
                    }
                }}
                onError={(err) => console.log(err)}
            />
        </PayPalScriptProvider>
    )
}   